/**
 * toggle sitemenu/sidebar with esc button
 * by ole fjarestad
 */
$( document ).on('keydown', function(e)
{
	if ( e.keyCode == 27 )
	{
		jQuery( '#js--siteMenu' ).toggleClass( 'isActive' );
		jQuery( '#js--topMenu' ).toggleClass( 'isActive' );
		jQuery( '#js--wrap' ).toggleClass( 'isActive' );
	}
});

/**
 * hide search input field when clicking outside it
 * by ole fjarestad
 */
$( document ).on('click', function(event)
{
	if ( $(event.target).closest('#js--topMenu__search').length == 0 )
	{
		$( '#js--topMenu__search' ).removeClass( 'isActive' );
	}
});



//////////////////
// WEBPACK FOOTER
// ./src/assets/js/partials/navigation.js
// module id = ./src/assets/js/partials/navigation.js
// module chunks = main